import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 8.5 4.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, white)",
      "fill-rule": "evenodd",
      d: "M.073.073a.25.25 0 0 1 .33-.02l.024.02L4.25 3.896 8.073.073a.25.25 0 0 1 .33-.02l.024.02a.25.25 0 0 1 .02.33l-.02.024-4 4a.25.25 0 0 1-.33.02l-.024-.02-4-4a.25.25 0 0 1 0-.354",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }